(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWithErrorHandling = fetchWithErrorHandling;

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GENERIC_ERROR = ["There was a server error, try again later."]; // const responseShape = shape({
//   success: bool.isRequired,
//   messageList: array.isRequired
// });

function fetchWithErrorHandling(props) {
  var url = props.url,
      onError = props.onError,
      options = props.options,
      _props$genericError = props.genericError,
      genericError = _props$genericError === void 0 ? GENERIC_ERROR : _props$genericError; // make sure we have a url and onError handler

  (0, _propTypes.checkPropTypes)({
    url: _propTypes.string.isRequired,
    onError: _propTypes.func.isRequired,
    options: _propTypes.object
  }, props, "prop", "fetchWithErrorHandling");

  var fetchOptions = _objectSpread({
    // credentials, to include cookies for backend
    credentials: "same-origin"
  }, options); // reset errors before fetching


  onError([]);
  return fetch(url, fetchOptions).then(function (response) {
    if (!response.ok) {
      throw new Error(response);
    }

    return response.json();
  }).then(function (response) {
    // checkPropTypes(responseShape, response, "response", url); this doesn't work properly :(
    var messageList = R.prop("messageList", response); // The api's we're working with don't have consistent responses, so try to
    // mitigate the errors by coding defensively here.

    if (!response || response.success === false) {
      if (R.type(messageList) === "String") {
        onError([messageList]);
      } else if (R.type(messageList) === "Array") {
        onError(messageList);
      } else {
        // return a generic message if we can't find a valid messageList
        onError(genericError);
      }
    }

    return response;
  }).catch(function (error) {
    onError(genericError);
    console.error(error);
  });
}

},{"prop-types":"prop-types","ramda":"ramda"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pushGoogleAnalyticsEvent;

function pushGoogleAnalyticsEvent(event) {
  if (window.dataLayer) {
    // console.log("pushing", event);
    window.dataLayer.push(event);
  } else {
    console.error("window.dataLayer is not defined!\nwindow.dataLayer: ", window.dataLayer);
  }
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollElementIntoView = scrollElementIntoView;
exports.scrollTo = scrollTo;
exports.scrollToElement = scrollToElement;

// Element -> Number
function getOffsetTop(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top;

  var scrollTop = getScrollTop();
  return top + scrollTop;
} // cross browser schinanigans


function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop;
}

function scrollToElement(element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  scrollTo(getOffsetTop(element) + offset);
}

function scrollElementIntoView(element) {
  var _element$getBoundingC2 = element.getBoundingClientRect(),
      height = _element$getBoundingC2.height;

  var viewportHeight = window.innerHeight;
  element.scrollIntoView({
    behavior: "smooth",
    block: height > viewportHeight ? "start" : "center"
  });
}

function scrollTo(top) {
  var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "smooth";
  window.scroll({
    top: top,
    left: 0,
    behavior: behavior
  });
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollToLastCard;

var _react = require("react");

var _scrollHelpers = require("./scrollHelpers.js");

/**
 * Check if an element and it's parents are visible
 * https://davidwalsh.name/offsetheight-visibility
 */
var isVisible = function isVisible(element) {
  if (element.offsetHeight === 0) {
    return false;
  } else if (element.parentNode) {
    return isVisible(element.parentNode);
  } else {
    return true;
  }
};

var isOnLastCard = false;

function useScrollToLastCard() {
  var dependencyArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var containerRef = (0, _react.useRef)(); // only run this effect _after_ the first render

  var hasRenderedOnce = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(function () {
    if (hasRenderedOnce.current === true && containerRef.current) {
      // cancel the autoscroll if the user scrolls first
      var handleScroll = function handleScroll() {
        clearTimeout(timeoutId);
        window.removeEventListener("scroll", handleScroll);
      };

      window.addEventListener("scroll", handleScroll); // delay the check for the last card to make sure all rendering has
      // finihsed, spinners are gone, and animations have settled, hack?

      var timeoutId = setTimeout(function () {
        var cards = Array.from(containerRef.current.querySelectorAll(".card"));
        var visibleCards = cards.filter(isVisible); // reset isOnLastCard if not on last card

        if (cards.length !== visibleCards.length) {
          isOnLastCard = false;
        } // scroll to next card after each step


        if (cards.length === visibleCards.length && !isOnLastCard) {
          var secondtolastCard = visibleCards[visibleCards.length - 2];
          isOnLastCard = true;
          (0, _scrollHelpers.scrollElementIntoView)(secondtolastCard);
        } else if (visibleCards.length > 0) {
          var lastCard = visibleCards[visibleCards.length - 1];
          (0, _scrollHelpers.scrollElementIntoView)(lastCard);
        }
      }, 400);
    }

    if (!hasRenderedOnce.current) {
      hasRenderedOnce.current = true;
    }
  }, dependencyArray // eslint-disable-line react-hooks/exhaustive-deps
  );
  return containerRef;
}

},{"./scrollHelpers.js":3,"react":"react"}],5:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yupZipValidationNotRequired = exports.yupZipValidation = void 0;

var Yup = _interopRequireWildcard(require("yup"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var yupZipValidation = Yup.string().min(5, "Zip code must be 5 characters").max(5, "Zip code cannot exceed 5 characters").matches(/^[\d-]*$/, "Zip code must be numeric").required("Zip code is required");
exports.yupZipValidation = yupZipValidation;
var yupZipValidationNotRequired = Yup.string().min(5, "Zip code must be 5 characters").max(5, "Zip code cannot exceed 5 characters").matches(/^[\d-]*$/, "Zip code must be numeric");
exports.yupZipValidationNotRequired = yupZipValidationNotRequired;

},{"yup":"yup"}],6:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAsyncValidationContext = exports.useAsyncValidation = exports.FormikAsyncValidationProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _excluded = ["formikProps", "asyncProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AsyncValidationContext = /*#__PURE__*/_react.default.createContext();
/**
 * state container for the async validation
 * @param  {Object} formikProps: return value from useFormik hook
 * @return {Object} asyncProps
 */


var useAsyncValidation = function useAsyncValidation(formikProps) {
  if (!formikProps) {
    console.error("You must provide formikProps to useAsyncValidation!");
  }

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      asyncErrors = _useState2[0],
      setAsyncFieldErrors = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      asyncLoading = _useState4[0],
      setAsyncLoading = _useState4[1];

  var setAsyncFieldError = function setAsyncFieldError(field, value) {
    if (value === undefined) {
      setAsyncFieldErrors(_objectSpread({}, R.omit([field], asyncErrors)));
    } else {
      setAsyncFieldErrors(_objectSpread(_objectSpread({}, asyncErrors), {}, _defineProperty({}, field, value)));
    }
  };
  /**
   * We need to keep track of async errors on our own, and merge them in with the
   * Yup validationSchema errors manually because formik can't handle this.
   * See https://github.com/jaredpalmer/formik/issues/706
   * @param  {Object} validationSchema Yup validation schema
   * @param  {Object} values : form values from formik
   * @return {Object} merged errors object for formik to consume
   */


  var validateWithAsync = function validateWithAsync(_ref) {
    var validationSchema = _ref.validationSchema,
        values = _ref.values;
    return validationSchema.validate(values, {
      abortEarly: false
    }).then(function (values) {
      // if we get this far, there are no yup errors!
      return _objectSpread({}, asyncErrors);
    }).catch(function (errors) {
      var yupErrors = parseValidationError(errors); // merge the yup errors with the async errors

      var combinedErrors = _objectSpread(_objectSpread({}, yupErrors), asyncErrors);

      return combinedErrors;
    });
  };

  return {
    asyncErrors: asyncErrors,
    setAsyncFieldError: setAsyncFieldError,
    asyncLoading: asyncLoading,
    setAsyncLoading: setAsyncLoading,
    validateWithAsync: validateWithAsync
  };
};
/**
 * Usage:
 *   const formikProps = useFormik({ ... });
 *   const asyncProps = useAsyncValidation(formikProps);
 *
 * <FormikAsyncValidationProvider
 *   formikProps={formikProps}
 *   asyncProps={asyncProps}
 * />
 *   ...
 * </FormikAsyncValidationProvider>
 * @param {Object} formikProps: return value from useFormik hook
 * @param {Object} asyncProps: return value from useAsyncValidation hook
 */


exports.useAsyncValidation = useAsyncValidation;

var FormikAsyncValidationProvider = function FormikAsyncValidationProvider(props) {
  var formikProps = props.formikProps,
      asyncProps = props.asyncProps,
      rest = _objectWithoutProperties(props, _excluded); // validate form is needed to force formik to revalidate after async work is done


  var validateForm = formikProps.validateForm;
  return /*#__PURE__*/_react.default.createElement(_formik.FormikProvider, {
    value: formikProps
  }, /*#__PURE__*/_react.default.createElement(AsyncValidationContext.Provider, _extends({
    value: _objectSpread(_objectSpread({}, asyncProps), {}, {
      validateForm: validateForm
    })
  }, rest)));
};

exports.FormikAsyncValidationProvider = FormikAsyncValidationProvider;
FormikAsyncValidationProvider.propTypes = {
  formikProps: _propTypes.object.isRequired,
  asyncProps: _propTypes.object.isRequired
};

var useAsyncValidationContext = function useAsyncValidationContext() {
  return (0, _react.useContext)(AsyncValidationContext);
};

exports.useAsyncValidationContext = useAsyncValidationContext;

var parseValidationError = function parseValidationError(error) {
  if (error.inner.length > 0) {
    return R.compose(R.reduce(R.mergeDeepRight, {}), R.map(parseValidationError), R.prop("inner"))(error);
  } else {
    var path = R.split(".", error.path);
    return R.assocPath(path, error.message, {});
  }
};

},{"formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react"}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _propTypes = require("prop-types");

var _Checkmark = _interopRequireDefault(require("../Icons/Checkmark.jsx"));

var _X = _interopRequireDefault(require("../Icons/X.jsx"));

var _Spinner = _interopRequireDefault(require("../Icons/Spinner.jsx"));

var _AsyncValidationContext = require("./AsyncValidationContext.jsx");

var _excluded = ["validateUrl", "name", "validText", "takenText", "renderError"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  name: _propTypes.string.isRequired,
  // eg. username or email
  validateUrl: _propTypes.string.isRequired,
  // endpoint that returns true/false
  validText: _propTypes.string,
  takenText: _propTypes.string,
  renderError: _propTypes.func.isRequired
};
var defaultProps = {
  validText: "Valid",
  takenText: "Taken"
}; // https://gist.github.com/jaredpalmer/a8faaab12bc37e6a160a3c9549664f0b
// This compoenent is used for the username and email inputs because they
// have similar behavior

var AsyncValidationInput = function AsyncValidationInput(props) {
  var validateUrl = props.validateUrl,
      name = props.name,
      validText = props.validText,
      takenText = props.takenText,
      renderError = props.renderError,
      rest = _objectWithoutProperties(props, _excluded);

  var formikProps = (0, _formik.useFormikContext)();
  var setFieldTouched = formikProps.setFieldTouched,
      formikHandleChange = formikProps.handleChange,
      formikHandleBlur = formikProps.handleBlur,
      values = formikProps.values,
      errors = formikProps.errors;

  var _useAsyncValidationCo = (0, _AsyncValidationContext.useAsyncValidationContext)(),
      setAsyncFieldError = _useAsyncValidationCo.setAsyncFieldError,
      setAsyncLoading = _useAsyncValidationCo.setAsyncLoading,
      validateForm = _useAsyncValidationCo.validateForm;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValidAsync = _useState2[0],
      setValidAsync = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1]; // only show the "valid" badge if it's passed both the async and yup validation


  var isValid = isValidAsync && !errors[name]; // let the context know that we're loading

  (0, _react.useEffect)(function () {
    setAsyncLoading(isLoading);
  }, [isLoading, setAsyncLoading]); // don't show the UI on a regular sync error

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAsyncError = _useState6[0],
      setIsAsyncError = _useState6[1];

  var inputValueRef = (0, _react.useRef)();
  var validateIsAvailable = (0, _react.useCallback)(function (value) {
    // exit early if we've already validated this value
    if (value === inputValueRef.current) {
      return;
    } // remember this for next time


    inputValueRef.current = value; // after async work, we need to update the formik errors object

    var forceRevalidate = function forceRevalidate() {
      validateForm();
    }; // reset


    setLoading(true);
    setValidAsync(false);
    setIsAsyncError(false); // the field must be "touched" in order for the error message to show up.
    // but formik "touches" on blur, we want to touch it as soon as it changes

    setFieldTouched(name, true);

    if (value) {
      // returns "true" or "false" of whether or not this value is available
      var url = "".concat(validateUrl, "?").concat(name, "=").concat(value); // credentials, to include cookies for backend

      return fetch(url, {
        credentials: "same-origin"
      }).then(function (response) {
        return response.json();
      }).then(function (isAvailable) {
        // let the async form context know we have an error
        // it's important to unset (undefined) when it's valid
        setAsyncFieldError(name, isAvailable ? undefined : renderError(value));
        setIsAsyncError(!isAvailable);
        setValidAsync(isAvailable);
        return isAvailable;
      }).finally(function () {
        setLoading(false);
        forceRevalidate();
      });
    } else {
      setLoading(false);
      setAsyncFieldError(name, undefined); // force a revalidate on the next tick, after the async validation has registered

      window.requestAnimationFrame(forceRevalidate);
      return Promise.resolve(true);
    }
  }, [name, renderError, setAsyncFieldError, setFieldTouched, validateForm, validateUrl]);
  var debouncedValidateIsAvailable = (0, _react.useCallback)((0, _lodash.default)(validateIsAvailable, 350), []);

  var handleChange = function handleChange(event) {
    formikHandleChange(event); // this will let Formik's default validation take place

    debouncedValidateIsAvailable(event.target.value);
  };

  var handleBlur = function handleBlur(event) {
    formikHandleBlur(event); // this will let Formik's default validation take place

    validateIsAvailable(event.target.value);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "async-validation-input input"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({}, rest, {
    value: values[name],
    name: name,
    onChange: handleChange,
    onBlur: handleBlur
  })), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "async-validation-input__spinner"
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    width: 24,
    height: 24
  })) : isValid ? /*#__PURE__*/_react.default.createElement("div", {
    className: "async-validation-input__valid"
  }, /*#__PURE__*/_react.default.createElement(_Checkmark.default, null), " ", validText) : isAsyncError && /*#__PURE__*/_react.default.createElement("div", {
    className: "async-validation-input__error"
  }, /*#__PURE__*/_react.default.createElement(_X.default, null), " ", takenText));
};

AsyncValidationInput.propTypes = propTypes;
AsyncValidationInput.defaultProps = defaultProps;
var _default = AsyncValidationInput;
exports.default = _default;

},{"../Icons/Checkmark.jsx":11,"../Icons/Spinner.jsx":12,"../Icons/X.jsx":13,"./AsyncValidationContext.jsx":6,"formik":"formik","lodash.debounce":"lodash.debounce","prop-types":"prop-types","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["name", "children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  name: _propTypes.any.isRequired,
  // could be string or number
  className: _propTypes.string,
  children: _propTypes.node.isRequired
}; // Common component to apply the correct classes for errors.
// Similar to Formik's Field component

var Label = function Label(props) {
  var name = props.name,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useFormikContext = (0, _formik.useFormikContext)(),
      touched = _useFormikContext.touched,
      errors = _useFormikContext.errors;

  return /*#__PURE__*/_react.default.createElement("label", _extends({
    className: (0, _classnames.default)(className, "form__label", {
      "form__label--has-error": touched[name] && errors[name]
    })
  }, rest), children);
};

Label.propTypes = propTypes;
var _default = Label;
exports.default = _default;

},{"classnames":"classnames","formik":"formik","prop-types":"prop-types","react":"react"}],9:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  serverErrors: (0, _propTypes.arrayOf)(_propTypes.string),
  headerText: _propTypes.string,
  onRenderEffect: _propTypes.func
};
var defaultProps = {
  serverErrors: [],
  headerText: "Uh oh!",
  onRenderEffect: function onRenderEffect() {}
};

var ServerErrors = function ServerErrors(props) {
  var serverErrors = props.serverErrors,
      headerText = props.headerText,
      onRenderEffect = props.onRenderEffect;
  var notificationsRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    return onRenderEffect(notificationsRef.current, serverErrors);
  }, [onRenderEffect, serverErrors]);
  return serverErrors.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "notification notification--error",
    ref: notificationsRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "notification__title"
  }, headerText), serverErrors.map(function (message) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: message,
      dangerouslySetInnerHTML: {
        __html: message
      }
    });
  }));
};

ServerErrors.propTypes = propTypes;
ServerErrors.defaultProps = defaultProps;
var _default = ServerErrors;
exports.default = _default;

},{"prop-types":"prop-types","react":"react"}],10:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _Popup = _interopRequireDefault(require("../Popup/Popup.jsx"));

var _excluded = ["name", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  name: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired
};

var TooltipInput = function TooltipInput(props) {
  var name = props.name,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      popupHidden = _useState2[0],
      setPopupHidden = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-input input"
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    name: name
  }, rest)), /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-input__question-mark",
    onMouseEnter: function onMouseEnter() {
      return setPopupHidden(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setPopupHidden(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_Popup.default, {
    top: 10,
    left: 10,
    offset: 10,
    width: 250,
    isHidden: popupHidden,
    nudgeToContain: ".body-wrapper" // .body-wrapper has overflow hidden
    ,
    nudgePadding: 5 // padding for box shadow

  }, children)));
};

TooltipInput.propTypes = propTypes;
var _default = TooltipInput;
exports.default = _default;

},{"../Popup/Popup.jsx":15,"formik":"formik","prop-types":"prop-types","react":"react"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {};

var Checkmark = function Checkmark(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    focusable: "false" // for IE 11
    ,
    width: 24,
    height: 24
  }, props), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "8",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M9.427 7.788s-.241-.757-2.133-.757c-1.891 0-.756 1.692-.756 1.692l3.446 6.055s.127.222.379.222.588-.445.588-.445l9.11-13.008c.253-.34.117-.539-.065-.543 0 0-1.205-.135-2.4 1.099-1.02 1.055-6.9 8.538-6.9 8.538z"
  }));
};

Checkmark.propTypes = propTypes;
var _default = Checkmark;
exports.default = _default;

},{"react":"react"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["color"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  color: _propTypes.string
};
var defaultProps = {
  color: "currentColor"
}; // something like this: https://loading.io/spinner/custom/275761/

var Spinner = function Spinner(props) {
  var color = props.color,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    focusable: "false" // for IE 11

  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "46",
    y: "2.5",
    rx: "92",
    ry: "5",
    width: "8",
    height: "25",
    fill: color
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
};

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
var _default = Spinner;
exports.default = _default;

},{"prop-types":"prop-types","react":"react"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {};

var X = function X(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    focusable: "false" // for IE 11
    ,
    width: 24,
    height: 24
  }, props), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "8",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M13 7l-6 6M13 13L7 7"
  }));
};

X.propTypes = propTypes;
var _default = X;
exports.default = _default;

},{"react":"react"}],14:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _excluded = ["isOpen", "onClose", "title", "children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  title: _propTypes.node,
  isOpen: _propTypes.bool.isRequired,
  onClose: _propTypes.func.isRequired,
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func])
};

var Modal = function Modal(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      title = props.title,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var modalContainer = (0, _react.useMemo)(function () {
    var container = document.createElement("div");
    container.setAttribute("class", "modal-container grower-portal");
    document.querySelector("#content").appendChild(container);
    return container;
  }, []);
  var overflowRef = (0, _react.useRef)(); // keep around the children so when we close, we can fade out with the content

  var childrenCache = (0, _react.useRef)(); // if children is a funciton, render it with some state

  var content = typeof children === "function" ? children({
    isOpen: isOpen,
    title: title
  }) : children;

  if (content) {
    childrenCache.current = content;
  } // listen for esc if the modal is open


  (0, _react.useEffect)(function () {
    var keydownHandler = function keydownHandler(e) {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      // always open with the modal scrolled to the top
      if (overflowRef.current) {
        overflowRef.current.scrollTo(0, 0);
      }

      window.addEventListener("keydown", keydownHandler);
      return function () {
        return window.removeEventListener("keydown", keydownHandler);
      };
    } else {
      window.removeEventListener("keydown", keydownHandler);
    }
  }, [isOpen, onClose]);
  (0, _react.useEffect)(function () {
    // document.querySelector("body").classList.toggle("modal-open", isOpen); can't use this because of IE11
    var classList = document.querySelector("body").classList;

    if (isOpen) {
      classList.add("modal-open");
    } else {
      classList.remove("modal-open");
    }
  }, [isOpen]);
  var classes = (0, _classnames.default)("modal", className, {
    "is-open": isOpen
  });

  var modalNode = /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes,
    role: "dialog",
    ref: overflowRef
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__box-holder"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__overlay",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_reactFocusLock.default, {
    disabled: !isOpen,
    returnFocus: true,
    className: "modal__box",
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__title"
  }, title, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "modal__close",
    onClick: onClose,
    "aria-label": "close"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    className: "octicon octicon-x",
    viewBox: "0 0 12 16",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal__content"
  }, childrenCache.current))));

  return /*#__PURE__*/_reactDom.default.createPortal(modalNode, modalContainer);
};

Modal.propTypes = propTypes;
var _default = Modal;
exports.default = _default;

},{"classnames":"classnames","prop-types":"prop-types","react":"react","react-dom":"react-dom","react-focus-lock":"react-focus-lock"}],15:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _calculatePopupOffsets = _interopRequireDefault(require("./calculatePopupOffsets.js"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  isHidden: _propTypes.bool,
  children: _propTypes.any,
  // content of the popup
  top: _propTypes.number.isRequired,
  left: _propTypes.number.isRequired,
  // having "auto" width can cause bugs when the popup butts up agains the side of the
  // viewport/parent container. The triangle might not point at the correct spot...
  // use a explict width if the popup might need to adjust by flipping/nudging
  width: _propTypes.number,
  onXClick: _propTypes.func,
  onFlip: _propTypes.func,
  offset: _propTypes.number,
  className: _propTypes.string,
  triangleSide: (0, _propTypes.oneOf)(["top", "right", "bottom", "left"]),
  flipToContain: _propTypes.string,
  flipPadding: _propTypes.number,
  nudgeToContain: _propTypes.string,
  nudgePadding: _propTypes.number
};
var defaultProps = {
  isHidden: false,
  triangleSide: "bottom"
};

var Popup = function Popup(props) {
  var top = props.top,
      left = props.left,
      offset = props.offset,
      triangleSide = props.triangleSide,
      children = props.children,
      className = props.className,
      isHidden = props.isHidden,
      onXClick = props.onXClick,
      onFlip = props.onFlip,
      width = props.width,
      flipToContain = props.flipToContain,
      flipPadding = props.flipPadding,
      nudgeToContain = props.nudgeToContain,
      nudgePadding = props.nudgePadding; // const [finalLeft, setLeft] = useState(0);
  // const [finalTop, setTop] = useState(0);
  // const [finalTriangleSide, setTriangleSide] = useState(triangleSide);
  // const [finalTriangleOffset, setTriangleOffset] = useState(0);

  var _useState = (0, _react.useState)({
    top: 0,
    // left/top will be calcualted before the popup is visible (see hasCalulatedPositionOnce)
    left: 0,
    triangleSide: triangleSide,
    triangleOffset: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var popup = (0, _react.useRef)();
  var triangle = (0, _react.useRef)();
  var prevTriangleSide = usePrevious(state.triangleSide); // if this popup is outside of it's parent, nudge it back in

  var calculatePositions = (0, _react.useCallback)(function () {
    var offsets = (0, _calculatePopupOffsets.default)({
      popup: popup.current,
      top: top,
      left: left,
      offset: offset,
      triangleSide: triangleSide,
      triangleSize: 12,
      // used to calculate the top value, should match css
      nudgeToContain: nudgeToContain,
      nudgePadding: nudgePadding,
      flipToContain: flipToContain,
      flipPadding: flipPadding
    }); // update the state with all the measurements

    setState({
      top: offsets.adjustedTop,
      left: offsets.adjustedLeft,
      triangleOffset: offsets.triangleOffset,
      triangleSide: offsets.triangleSide
    });
  }, [flipPadding, flipToContain, left, nudgePadding, nudgeToContain, offset, top, triangleSide]); // attach scroll and resize listeners

  (0, _react.useEffect)(function () {
    var debouncedRecalc = (0, _lodash.default)(calculatePositions, 250);
    window.addEventListener("scroll", debouncedRecalc);
    window.addEventListener("resize", debouncedRecalc);
    return function () {
      window.removeEventListener("scroll", debouncedRecalc);
      window.removeEventListener("resize", debouncedRecalc);
      debouncedRecalc.cancel();
    };
  }, [calculatePositions]); // calculate the position when stuff changes

  (0, _react.useEffect)(function () {
    if (!isHidden) {
      calculatePositions();
    }
  }, [calculatePositions, isHidden, top, left, width]); // call onFlip if we've flipped

  (0, _react.useEffect)(function () {
    if (state.triangleSide !== prevTriangleSide && onFlip) {
      onFlip(state.triangleSide);
    }
  });
  var popupClasses = (0, _classnames.default)("popup", "is-triangle-".concat(state.triangleSide), className, {
    "is-hidden": isHidden
  });
  var popupStyles = {
    position: "absolute",
    top: state.top,
    left: state.left,
    width: width
  }; // center the triangle and nudge if needed

  var triangleStyles = {
    transform: state.triangleSide === "top" || state.triangleSide === "bottom" ? "translateX(".concat(state.triangleOffset, "px)") // top/bottom
    : "translateY(".concat(state.triangleOffset, "px)") // left/right

  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: popupClasses,
    style: popupStyles,
    ref: popup
  }, // if there is an onXClick handler, show the X
  onXClick && /*#__PURE__*/_react.default.createElement("div", {
    className: "popup__close",
    onClick: onXClick
  }, "X"), /*#__PURE__*/_react.default.createElement("div", {
    className: "popup__html"
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: "popup__triangle",
    ref: triangle,
    style: triangleStyles
  }));
};

Popup.propTypes = propTypes;
Popup.defaultProps = defaultProps;
var _default = Popup; // https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state

exports.default = _default;

function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}

},{"./calculatePopupOffsets.js":16,"classnames":"classnames","lodash.debounce":"lodash.debounce","prop-types":"prop-types","react":"react"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePopupOffsets;

var _propTypes = require("prop-types");

/**
 * calculatePopupPositions: find the top/left
 * @param {element} popup          : DOM elmenet of the popup to be placed
 * @param {number}  top            : The top coordinate of where the popup should point
 * @param {number}  left           : The left coordinate of where the popup should point
 * @param {number}  offset         : an offet to be added to top/bottom or left/right
 * @param {string}  triangleSide   : "top", "right", "bottom", or "left"
 * @param {number}  triangleSize   : used to calculate the position
 * @param {boolean} flipToContain  : "parent", "viewport", or a parent selector. will flip the popup if it goes outside the container
 *                                   undefined will not flip at all
 * @param {number}  flipPadding    : amount the popup should be away from the edge when flipped
 * @param {string}  nudgeToContain : "parent", viewport", or a parent selector. will nudge the popup to stay in the container
 *                                   undefined will not nudge at all
 * @param {number}  nudgePadding   : amount the popup should be away from the edge when nudged
 * @return {object}  {
 *     relativeTop    : with no offset adjustment, the popup should go here, based on triangleSide, relative to parent
 *     relativeLeft   : ^^
 *     adjustedTop    : with adjustment from nudging or flipping
 *     adjustedLeft   : ^^
 *     overflow       : "top", "right", "bottom", "left".  Positive numbers are overflows
 *     triangleOffset : Amount the triangle needs to move to be on the dot, relative from 50%
 *     triangleSide   : Will be the same as passed in triangleSide, unless it fliped via flipToContain
 * }
 * use adjustedTop, adjustedLeft, and triangleOffset to position the popup
 */
function calculatePopupOffsets(props) {
  var popup = props.popup,
      top = props.top,
      left = props.left,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      _props$triangleSide = props.triangleSide,
      triangleSide = _props$triangleSide === void 0 ? "bottom" : _props$triangleSide,
      _props$triangleSize = props.triangleSize,
      triangleSize = _props$triangleSize === void 0 ? 12 : _props$triangleSize,
      flipToContain = props.flipToContain,
      nudgeToContain = props.nudgeToContain,
      _props$nudgePadding = props.nudgePadding,
      nudgePadding = _props$nudgePadding === void 0 ? 0 : _props$nudgePadding,
      _props$flipPadding = props.flipPadding,
      flipPadding = _props$flipPadding === void 0 ? 0 : _props$flipPadding;
  (0, _propTypes.checkPropTypes)({
    popup: _propTypes.object.isRequired,
    top: _propTypes.number.isRequired,
    left: _propTypes.number.isRequired,
    triangleSide: (0, _propTypes.oneOf)(["top", "right", "bottom", "left"]),
    triangleSize: _propTypes.number,
    flipToContain: _propTypes.string,
    nudgeToContain: _propTypes.string
  }, props, "prop", "calculatePopupOffsets"); // get the width and height of this popup from the DOM
  // using offsetWidth/offsetHeight isntead of getBoundingClientRect because offsetWidth doesn't account for scale(0.9)

  var width = popup.offsetWidth;
  var height = popup.offsetHeight; // common calculations

  var popupOnTop = top - height - triangleSize - offset;
  var popupOnBottom = top + triangleSize + offset;
  var popupOnLeft = left - width - triangleSize - offset;
  var popupOnRight = left + triangleSize + offset; // calculate where the top of the popup should be based on top/left

  var relativeTop = triangleSide === "bottom" ? popupOnTop : triangleSide === "top" ? popupOnBottom : top - height / 2; //  left or right

  var relativeLeft = triangleSide === "right" ? popupOnLeft : triangleSide === "left" ? popupOnRight : left - width / 2; // center

  var realRight = relativeLeft + width;
  var realBottom = relativeTop + height; // get a bounding rect relative to the viewport

  var getContainerRect = function getContainerRect(value) {
    if (value === "viewport") {
      return {
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight
      };
    } else if (value === "parent") {
      return popup.parentNode.getBoundingClientRect();
    } else if (typeof value === "string") {
      var el = popup.closest(value);
      return el ? el.getBoundingClientRect() : null;
    } else {
      return null;
    }
  };

  var nudgeContainerRect = getContainerRect(nudgeToContain);
  var flipContainerRect = getContainerRect(flipToContain);
  var topBottom = triangleSide === "top" || triangleSide === "bottom";
  var leftRight = triangleSide === "left" || triangleSide === "right";
  var horizontalContainerRect = topBottom ? nudgeContainerRect : flipContainerRect;
  var verticalContainerRect = leftRight ? nudgeContainerRect : flipContainerRect;
  var horizontalPadding = topBottom ? nudgePadding : flipPadding;
  var verticalPadding = leftRight ? nudgePadding : flipPadding;
  var parentRect = popup.parentNode.getBoundingClientRect(); // calculate what getBoundingClientRect would be for the relative values (relative to the parent)

  var popupRect = {
    top: parentRect.top + relativeTop - verticalPadding,
    right: parentRect.left + realRight + horizontalPadding,
    bottom: parentRect.top + realBottom + verticalPadding,
    left: parentRect.left + relativeLeft - horizontalPadding,
    width: width,
    height: height
  }; // calcluate how much the popup goes outside the containers (positive number are outside)

  var overflow = {
    top: verticalContainerRect ? verticalContainerRect.top - popupRect.top : -1 * popupRect.top,
    left: horizontalContainerRect ? horizontalContainerRect.left - popupRect.left : -1 * popupRect.left,
    bottom: verticalContainerRect ? popupRect.bottom - verticalContainerRect.bottom : -1 * (parentRect.height - (parentRect.bottom - window.innerHeight)),
    right: horizontalContainerRect ? popupRect.right - horizontalContainerRect.right : -1 * (parentRect.width - (parentRect.right - window.innerWidth))
  }; // calculate where the popup should go
  // start with adjustedLeft as relativeLeft before nudging

  var adjustedTop = relativeTop;
  var adjustedLeft = relativeLeft;
  var triangleOffset = 0;
  var newTriangleSide = triangleSide; // make a copy of this so we can override it if it flips
  // don't nudge the popup too far if the point the popup is supposed to be
  // pointing at is off the screen

  function getNudge(overflow, heightOrWidth) {
    var BORDER_RADIUS = 6;
    return Math.min(overflow, heightOrWidth / 2 - triangleSize - BORDER_RADIUS);
  } // if there is an overflow on the right, adjust the popup and triangle position


  if (overflow.right > 0) {
    if (triangleSide === "top" || triangleSide === "bottom") {
      var nudge = getNudge(overflow.right, width);
      adjustedLeft = relativeLeft - nudge;
      triangleOffset = nudge;
    } // for left, flip the popup
    else if (triangleSide === "left" && flipToContain) {
      newTriangleSide = "right";
      adjustedLeft = popupOnLeft;
    }
  } // if there is an overflow on the left, adjust the popup and triangle position


  if (overflow.left > 0) {
    if (triangleSide === "top" || triangleSide === "bottom") {
      var _nudge = getNudge(overflow.left, width);

      adjustedLeft = relativeLeft + _nudge;
      triangleOffset = -_nudge;
    } // for right, flip the popup
    else if (triangleSide === "right" && flipToContain) {
      newTriangleSide = "left";
      adjustedLeft = popupOnRight;
    }
  } // if there is an overflow on the bottom


  if (overflow.bottom > 0) {
    // for left/right, butt the popup against the bottom
    if (triangleSide === "left" || triangleSide === "right") {
      var _nudge2 = getNudge(overflow.bottom, height);

      adjustedTop = relativeTop - _nudge2;
      triangleOffset = _nudge2;
    } // for top, flip the popup
    else if (triangleSide === "top" && flipToContain) {
      newTriangleSide = "bottom";
      adjustedTop = popupOnTop;
    }
  } // if there is an overflow on the top


  if (overflow.top > 0) {
    if (triangleSide === "left" || triangleSide === "right") {
      var _nudge3 = getNudge(overflow.top, height);

      adjustedTop = relativeTop + _nudge3;
      triangleOffset = -_nudge3;
    } // for bottom, flip the popup


    if (triangleSide === "bottom" && flipToContain) {
      newTriangleSide = "top";
      adjustedTop = popupOnBottom;
    }
  } // return all the measurements


  return {
    relativeTop: relativeTop,
    relativeLeft: relativeLeft,
    adjustedTop: adjustedTop,
    adjustedLeft: adjustedLeft,
    triangleOffset: nudgeToContain ? triangleOffset : 0,
    popupTop: leftRight && nudgeToContain || topBottom && flipToContain ? adjustedTop : relativeTop,
    popupLeft: topBottom && nudgeToContain || leftRight && flipToContain ? adjustedLeft : relativeLeft,
    triangleSide: flipToContain ? newTriangleSide : triangleSide
  };
}

},{"prop-types":"prop-types"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _RadioGroup = require("./RadioGroup.jsx");

var _excluded = ["children", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  children: _propTypes.node,
  checked: _propTypes.bool,
  value: _propTypes.any,
  name: _propTypes.string,
  onChange: _propTypes.func,
  defaultChecked: _propTypes.bool
}; // component to use with a RadioGroup

var Radio = function Radio(props) {
  return /*#__PURE__*/_react.default.createElement(_RadioGroup.RadioGroupContext.Consumer, null, function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var children = props.children,
        value = props.value,
        otherProps = _objectWithoutProperties(props, _excluded); // get the prop from props or context


    var valueOf = function valueOf(prop) {
      return props[prop] || context[prop];
    }; // make sure defaultValue/selectedValue is on the context first, because
    // `undefined === value` will return false; false is not the same as
    // undefined for defaultChecked/checked


    var defaultChecked = props.defaultChecked || context.defaultValue && context.defaultValue === value;
    var checked = props.checked || context.selectedValue && context.selectedValue === value;

    var _onChange = valueOf("onChange") || function () {};

    return /*#__PURE__*/_react.default.createElement("label", {
      className: "radio"
    }, /*#__PURE__*/_react.default.createElement("input", _extends({
      type: "radio",
      defaultChecked: defaultChecked,
      checked: checked,
      "aria-checked": checked || defaultChecked,
      name: valueOf("name"),
      onChange: function onChange() {
        return _onChange(value);
      }
    }, otherProps)), /*#__PURE__*/_react.default.createElement("span", {
      className: "radio__custom"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "radio__label"
    }, children));
  });
};

Radio.propTypes = propTypes;
var _default = Radio;
exports.default = _default;

},{"./RadioGroup.jsx":18,"prop-types":"prop-types","react":"react"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioGroupContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["name", "onChange", "selectedValue", "children", "as"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioGroupContext = /*#__PURE__*/_react.default.createContext({});

exports.RadioGroupContext = RadioGroupContext;
var propTypes = {
  children: _propTypes.node,
  name: _propTypes.string.isRequired,
  selectedValue: _propTypes.any,
  defaultValue: _propTypes.any,
  onChange: _propTypes.func,
  as: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.object])
};
var defaultProps = {
  as: "div"
};
/**
 * similar API as https://github.com/chenglou/react-radio-group
 */

var RadioGroup = function RadioGroup(props) {
  /* eslint-disable no-unused-vars */
  var name = props.name,
      onChange = props.onChange,
      selectedValue = props.selectedValue,
      children = props.children,
      Component = props.as,
      otherProps = _objectWithoutProperties(props, _excluded);
  /* eslint-enable no-unused-vars */


  return /*#__PURE__*/_react.default.createElement(RadioGroupContext.Provider, {
    value: props
  }, /*#__PURE__*/_react.default.createElement(Component, otherProps, children));
};

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
var _default = RadioGroup;
exports.default = _default;

},{"prop-types":"prop-types","react":"react"}],19:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _RegistrationContext = require("./RegistrationContext.jsx");

var _useRecaptchaCheckbox2 = _interopRequireDefault(require("./useRecaptchaCheckbox.js"));

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = require("prop-types");

var _api = require("../../common/api.js");

var _useScrollToLastCard_RegistrationForm = _interopRequireDefault(require("../../common/useScrollToLastCard_RegistrationForm.js"));

var Yup = _interopRequireWildcard(require("yup"));

var _validation = require("../../common/validation.js");

var _pushGoogleAnalyticsEvent = _interopRequireDefault(require("../../common/pushGoogleAnalyticsEvent.js"));

var _formik = require("formik");

var _Step = _interopRequireDefault(require("./Step0.jsx"));

var _Step2 = _interopRequireDefault(require("./Step1.jsx"));

var _Step3 = _interopRequireDefault(require("./Step2.jsx"));

var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));

var _Spinner = _interopRequireDefault(require("../Icons/Spinner.jsx"));

var _Modal = _interopRequireDefault(require("../Modal/Modal.jsx"));

var _AsyncValidationContext = require("../Form/AsyncValidationContext.jsx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {}; // for tesing, set this to a higher number to see all steps

var INITIAL_STEP = 0;

var Registration = function Registration(props) {
  var _useRegistrationConte = (0, _RegistrationContext.useRegistrationContext)(),
      data = _useRegistrationConte.data,
      isTechIdModalOpen = _useRegistrationConte.state.isTechIdModalOpen,
      setTechIdModalOpen = _useRegistrationConte.actions.setTechIdModalOpen;

  var captchaSiteKey = data.captchaSiteKey,
      headerBannerImage = data.headerBannerImage,
      headerBannerTitle = data.headerBannerTitle,
      headerRichText = data.headerRichText,
      bayerPlusHeaderBannerImage = data.bayerPlusHeaderBannerImage,
      bayerPlusHeaderBannerTitle = data.bayerPlusHeaderBannerTitle,
      bayerPlusHeaderRichText = data.bayerPlusHeaderRichText,
      bayerPlusBlueText = data.bayerPlusBlueText,
      isBayerPlusRegistration = data.isBayerPlusRegistration,
      isHighflyerRegistration = data.isHighflyerRegistration,
      registerEndpoint = data.registerEndpoint,
      techIdLookupText = data.techIdLookupText,
      completeRegistrationText = data.completeRegistrationText,
      openTechIdModalLinkText = data.openTechIdModalLinkText,
      techIdModalBody = data.techIdModalBody,
      usernameSubtitle = data.usernameSubtitle;
  var condHeaderBannerImage = isBayerPlusRegistration ? bayerPlusHeaderBannerImage : headerBannerImage;
  var condHeaderBannerTitle = isBayerPlusRegistration ? bayerPlusHeaderBannerTitle : headerBannerTitle;
  var condHeaderRichText = isBayerPlusRegistration ? bayerPlusHeaderRichText : headerRichText;

  var handleTechIdModalLinkClick = function handleTechIdModalLinkClick(e) {
    e.preventDefault();
    setTechIdModalOpen(true);
  }; // errors that came back from the api


  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      serverErrors = _useState2[0],
      setServerErrors = _useState2[1];

  var _useState3 = (0, _react.useState)(INITIAL_STEP),
      _useState4 = _slicedToArray(_useState3, 2),
      step = _useState4[0],
      setStep = _useState4[1];

  var containerRef = (0, _useScrollToLastCard_RegistrationForm.default)([step]);

  var _useRecaptchaCheckbox = (0, _useRecaptchaCheckbox2.default)(captchaSiteKey),
      recaptchaRef = _useRecaptchaCheckbox.recaptchaRef,
      captchaToken = _useRecaptchaCheckbox.captchaToken;

  (0, _react.useEffect)(function () {
    if (captchaToken) {
      setFieldValue("g-recaptcha-response", captchaToken);
    }
  }, [captchaToken, setFieldValue]);
  var validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    suffix: Yup.string(),
    email: Yup.string().email("Invalid email") // email async validation handled by <AsyncValidationInput />
    .required("Email is required"),
    confirmEmail: Yup.string().oneOf([Yup.ref("email")], "Email and Confirmation Email must match").required("Confirmation Email is required"),
    postalCode: _validation.yupZipValidation,
    phoneNumber: Yup.string().min(10, "Mobile Phone Number must be exactly 10 digits").max(10, "Mobile Phone Number must be exactly 10 digits").matches(/^\d+$/, "Mobile Phone Number must be exactly 10 digits").required("Mobile Phone Number is required"),
    username: Yup.string() // username async validation handled by <AsyncValidationInput />
    .test({
      name: "username-characters",
      test: function test(value) {
        return /^[A-Za-z0-9\@\_\.]+$/.test(value);
      },
      message: usernameSubtitle
    }).required("Username is required").max(32, "Username must be at most 32 characters"),
    // https://til.hashrocket.com/posts/vahuw4phan-check-the-password-confirmation-with-yup
    password: Yup.string().test({
      name: "password-characters",
      test: function test(value) {
        return /^[A-Za-z0-9]+$/.test(value);
      },
      message: "Password can only contain letters and numbers"
    }).min(8, "Password must be at least ${min} characters").max(15, "Password must be at most ${max} characters").required("Password is required"),
    confirmPassword: Yup.string().oneOf([Yup.ref("password")], "Passwords must match").required("Please confirm your password"),
    // climate fieldview email validation
    climateFieldViewChoice: Yup.string().required("Please select one of the two options provided"),
    climateFieldViewEmail: Yup.string().when("climateFieldViewChoice", {
      is: "yes",
      then: Yup.string().email("Invalid email").required("Email is required"),
      otherwise: Yup.string()
    }),
    climateFieldViewPhoneNumber: Yup.string().when("climateFieldViewChoice", {
      is: "yes",
      then: Yup.string().min(10, "Mobile Phone Number must be exactly 10 digits").max(10, "Mobile Phone Number must be exactly 10 digits").matches(/^\d+$/, "Mobile Phone Number must be exactly 10 digits").required("Phone Number is required"),
      otherwise: Yup.string()
    }),
    climateFieldViewDealerEmail: Yup.string(),
    // optInt: ,
    privacyPolicy: Yup.boolean().oneOf([true], "You must accept the Terms & Conditions").required("You must accept the Terms & Conditions"),
    "g-recaptcha-response": Yup.string().nullable().required("Please prove that you are not a robot")
  });
  var formikProps = (0, _formik.useFormik)({
    initialValues: {
      firstName: "",
      lastName: "",
      suffix: "",
      email: "",
      confirmEmail: "",
      phoneNumber: "",
      postalCode: "",
      username: "",
      password: "",
      confirmPassword: "",
      climateFieldViewChoice: "",
      climateFieldViewEmail: "",
      climateFieldViewPhoneNumber: "",
      climateFieldViewDealerEmail: "",
      optIn: "",
      privacyPolicy: false,
      bayerPlusEnrollment: false,
      "g-recaptcha-response": captchaToken
    },
    validate: function validate(values) {
      return validateWithAsync({
        validationSchema: validationSchema,
        values: values
      });
    },
    onSubmit: function onSubmit(values, formikBag) {
      return new Promise(function (resolve, reject) {
        var formattedValues = R.evolve({
          phoneNumber: R.replace(/\D/g, "")
        })(values);
        return (0, _api.fetchWithErrorHandling)({
          url: registerEndpoint,
          onError: setServerErrors,
          options: {
            method: "POST",
            body: JSON.stringify(formattedValues),
            headers: {
              "Content-Type": "application/json"
            }
          }
        }).then(function (response) {
          var success = response.success,
              redirectUrl = response.redirectUrl;

          if (success) {
            var button = formattedValues.continueToBayerPlus ? techIdLookupText : completeRegistrationText;
            (0, _pushGoogleAnalyticsEvent.default)({
              event: "gaGenericEvent",
              eventCategory: "Registration",
              eventAction: "Successful",
              eventLabel: "Step 1 - ".concat(button)
            });
            var climateFieldViewAction = values.climateFieldViewChoice === "yes" ? "Accept" : "Reject";
            (0, _pushGoogleAnalyticsEvent.default)({
              event: "gaGenericEvent",
              eventCategory: "Bayer Plus ClimateField (local)",
              eventAction: "".concat(climateFieldViewAction),
              eventLabel: "Signup"
            });
            location.assign(redirectUrl);
          }

          return response;
        }).then(R.tap(resolve)).catch(function (error) {
          console.error(error);
          reject(error);
        });
      });
    }
  });
  var values = formikProps.values,
      errors = formikProps.errors,
      isSubmitting = formikProps.isSubmitting,
      isValid = formikProps.isValid,
      submitCount = formikProps.submitCount,
      submitForm = formikProps.submitForm,
      setFieldValue = formikProps.setFieldValue; // console.log(formikProps);

  var asyncProps = (0, _AsyncValidationContext.useAsyncValidation)(formikProps);
  var validateWithAsync = asyncProps.validateWithAsync,
      asyncLoading = asyncProps.asyncLoading; // Show an error message below the submit buttons if the form has been submitted
  // and there are client errors

  (0, _react.useEffect)(function () {
    if (!isValid && submitCount > 0) {
      setServerErrors(["Please correct errors above before submitting."]);
    } else {
      setServerErrors([]);
    }
  }, [isValid, submitCount]);
  var lastValues = usePrevious(values);
  var lastErrors = usePrevious(errors);
  var stepRequirements = [["firstName", "lastName", "email", "confirmEmail", "phoneNumber", "postalCode"], ["username", "password", "confirmPassword"], ["privacyPolicy"]];

  var hasValidValue = function hasValidValue(key) {
    return values[key] !== "" && values[key] !== false && // required checkboxes should not be false
    !R.isNil(values[key]) && errors[key] === undefined;
  };

  var checkStep = function checkStep() {
    // don't advance if async validation is loading
    if (asyncLoading) {
      return;
    }

    var nextStep = stepRequirements.reduce(function (nextStep, fields, i) {
      return R.all(hasValidValue, fields) ? i + INITIAL_STEP + 1 : nextStep;
    }, INITIAL_STEP);

    if (nextStep !== step) {
      setStep(nextStep);
    }
  };

  if (!R.equals(lastValues, values) || !R.equals(lastErrors, errors) || !asyncLoading) {
    checkStep();
  }

  var handleTechIdClick = function handleTechIdClick(e) {
    setFieldValue("continueToBayerPlus", true);
    submitForm();
  };

  var handleCompleteRegistrationClick = function handleCompleteRegistrationClick(e) {
    setFieldValue("continueToBayerPlus", values["bayerPlusEnrollment"]);
    submitForm();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__holder grower-portal",
    ref: containerRef
  }, condHeaderBannerImage && /*#__PURE__*/_react.default.createElement("div", {
    className: "card__banner"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: condHeaderBannerImage,
    alt: "",
    role: "presentation"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h1", null, condHeaderBannerTitle), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: condHeaderRichText
    }
  }), " ", isBayerPlusRegistration && /*#__PURE__*/_react.default.createElement("a", {
    href: "#what-is-tech-id",
    onClick: handleTechIdModalLinkClick
  }, openTechIdModalLinkText)), bayerPlusBlueText && /*#__PURE__*/_react.default.createElement("div", {
    className: "blue-notification",
    dangerouslySetInnerHTML: {
      __html: bayerPlusBlueText
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__sub-note",
    style: {
      marginTop: 24
    }
  }, "All fields are required unless marked as optional.")), /*#__PURE__*/_react.default.createElement(_AsyncValidationContext.FormikAsyncValidationProvider, {
    formikProps: formikProps,
    asyncProps: asyncProps
  }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement(_Step.default, data), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
    height: step >= 1 ? "auto" : 0
  }, /*#__PURE__*/_react.default.createElement(_Step2.default, data)), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
    height: step >= 2 ? "auto" : 0
  }, /*#__PURE__*/_react.default.createElement(_Step3.default, _extends({}, data, {
    formValues: formikProps.values,
    errors: formikProps.errors,
    touched: formikProps.touched,
    setFieldValue: formikProps.setFieldValue,
    setFieldTouched: formikProps.setFieldTouched,
    onTechIdClick: handleTechIdClick,
    onCompleteRegistrationClick: handleCompleteRegistrationClick,
    serverErrors: serverErrors,
    isSubmitting: isSubmitting,
    recaptchaRef: recaptchaRef
  }))), isSubmitting && /*#__PURE__*/_react.default.createElement("div", {
    className: "form__submitting"
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    width: 48,
    height: 48
  }), /*#__PURE__*/_react.default.createElement("div", null, "Submitting...")))), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    isOpen: isTechIdModalOpen,
    onClose: function onClose() {
      return setTechIdModalOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__modal",
    dangerouslySetInnerHTML: {
      __html: techIdModalBody
    }
  })));
};

Registration.propTypes = propTypes;
var _default = Registration;
exports.default = _default;

function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}

},{"../../common/api.js":1,"../../common/pushGoogleAnalyticsEvent.js":2,"../../common/useScrollToLastCard_RegistrationForm.js":4,"../../common/validation.js":5,"../Form/AsyncValidationContext.jsx":6,"../Icons/Spinner.jsx":12,"../Modal/Modal.jsx":14,"./RegistrationContext.jsx":20,"./Step0.jsx":21,"./Step1.jsx":22,"./Step2.jsx":23,"./useRecaptchaCheckbox.js":24,"formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","yup":"yup"}],20:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationProvider = void 0;
exports.useRegistrationContext = useRegistrationContext;

var _react = _interopRequireWildcard(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RegistrationContext = /*#__PURE__*/_react.default.createContext();

var initialState = {
  isTechIdModalOpen: false
};
var actionHandlers = {
  setTechIdModalOpen: {
    action: function action(isTechIdModalOpen) {
      return {
        type: "setTechIdModalOpen",
        payload: {
          isTechIdModalOpen: isTechIdModalOpen
        }
      };
    },
    reducer: function reducer(state, action) {
      var isTechIdModalOpen = action.payload.isTechIdModalOpen;
      return _objectSpread(_objectSpread({}, state), {}, {
        isTechIdModalOpen: isTechIdModalOpen
      });
    }
  }
};
/**
 * Reducer
 * Looks in the `actionHandlers` object for a key that mathces `action.type`
 * if it finds it, run the associated reducer.
 */

var stateReducer = function stateReducer(state, action) {
  // console.log(action.type, action.payload);
  if (actionHandlers[action.type]) {
    return actionHandlers[action.type].reducer(state, action);
  } // if an action wasn't found, log a warning


  console.warn("Action not found!", action);
  return state;
};
/**
 * RegistrationProvider, has the value built inspect
 * usage:
 *   <RegistrationProvider> ... </RegistrationProvider>
 */


var RegistrationProvider = function RegistrationProvider(props) {
  var data = props.data;

  var _useReducer = (0, _react.useReducer)(stateReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var context = {
    data: data,
    state: state,
    actions: R.compose(R.map(function (fn) {
      return function () {
        return dispatch(fn.apply(void 0, arguments));
      };
    }), R.pluck("action"))(actionHandlers)
  };
  return /*#__PURE__*/_react.default.createElement(RegistrationContext.Provider, _extends({
    value: context
  }, props));
};

exports.RegistrationProvider = RegistrationProvider;
RegistrationProvider.propTypes = {
  data: _propTypes.object.isRequired
};
/**
 * useRegistrationContext
 * usage:
 *   const {
 *     state: { path },
 *     actions: { setPath }
 *   } = useRegistrationContext();
 */

function useRegistrationContext() {
  return (0, _react.useContext)(RegistrationContext);
}

},{"prop-types":"prop-types","ramda":"ramda","react":"react"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _Label = _interopRequireDefault(require("../Form/Label.jsx"));

var _AsyncValidationInput = _interopRequireDefault(require("../Form/AsyncValidationInput.jsx"));

var _TooltipInput = _interopRequireDefault(require("../Form/TooltipInput.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  firstNameLabel: _propTypes.string,
  lastNameLabel: _propTypes.string,
  emailAddressLabel: _propTypes.string,
  confirmEmailAddressLabel: _propTypes.string,
  suffixLabel: _propTypes.string,
  zipCodeLabel: _propTypes.string,
  zipCodeSubtitle: _propTypes.string.isRequired,
  verifyEmailEndpoint: _propTypes.string.isRequired,
  loginUrl: _propTypes.string.isRequired,
  firstScreenHeaderText: _propTypes.string.isRequired,
  phoneNumberLabel: _propTypes.string,
  phoneNumberTooltip: _propTypes.string.isRequired
};
var defaultProps = {
  firstNameLabel: "First Name",
  lastNameLabel: "Last Name",
  emailAddressLabel: "Email Address",
  confirmEmailAddressLabel: "Confirm Email Address",
  suffixLabel: "Suffix",
  zipCodeLabel: "ZIP Code",
  phoneNumberLabel: "Mobile Phone Number",
  phoneNumberTooltip: ""
};

var Step0 = function Step0(props) {
  var firstNameLabel = props.firstNameLabel,
      lastNameLabel = props.lastNameLabel,
      emailAddressLabel = props.emailAddressLabel,
      confirmEmailAddressLabel = props.confirmEmailAddressLabel,
      zipCodeLabel = props.zipCodeLabel,
      zipCodeSubtitle = props.zipCodeSubtitle,
      suffixLabel = props.suffixLabel,
      verifyEmailEndpoint = props.verifyEmailEndpoint,
      loginUrl = props.loginUrl,
      firstScreenHeaderText = props.firstScreenHeaderText,
      phoneNumberLabel = props.phoneNumberLabel,
      phoneNumberTooltip = props.phoneNumberTooltip;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h2", null, firstScreenHeaderText), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__fields"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "firstName"
  }, firstNameLabel, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "firstName",
    placeholder: "First Name"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "firstName"
  }))), /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "lastName"
  }, lastNameLabel, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "lastName",
    placeholder: "Last Name"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "lastName"
  }))), /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "suffix",
    className: "form__label--suffix"
  }, suffixLabel, " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "registration__optional"
  }, "(opt.)"), /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "suffix",
    placeholder: ""
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "suffix"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "email"
  }, emailAddressLabel, /*#__PURE__*/_react.default.createElement(_AsyncValidationInput.default, {
    name: "email",
    validateUrl: verifyEmailEndpoint,
    placeholder: "email@host.com",
    renderError: function renderError(email) {
      return /*#__PURE__*/_react.default.createElement("span", null, "That email address is already being used. Please ", /*#__PURE__*/_react.default.createElement("a", {
        href: loginUrl
      }, "log in to your account"), " or ", /*#__PURE__*/_react.default.createElement("a", {
        href: "/contact/bayer-plus-rewards-support"
      }, "contact support"), ".");
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "email"
  }))), /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "confirmEmail"
  }, confirmEmailAddressLabel, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "confirmEmail",
    placeholder: "ConfirmEmail"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "confirmEmail"
  }))), /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "phoneNumber"
  }, phoneNumberLabel, /*#__PURE__*/_react.default.createElement(_TooltipInput.default, {
    name: "phoneNumber",
    placeholder: "xxx-xxx-xxxx"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-input__popup-title"
  }, "Why Mobile Phone Number?"), /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: phoneNumberTooltip
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "phoneNumber"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "postalCode"
  }, zipCodeLabel, /*#__PURE__*/_react.default.createElement(_TooltipInput.default, {
    name: "postalCode",
    placeholder: "#####"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-input__popup-title"
  }, "Why my ZIP code?"), /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: zipCodeSubtitle
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "postalCode"
  }))))));
};

Step0.propTypes = propTypes;
Step0.defaultProps = defaultProps;
var _default = Step0;
exports.default = _default;

},{"../Form/AsyncValidationInput.jsx":7,"../Form/Label.jsx":8,"../Form/TooltipInput.jsx":10,"formik":"formik","prop-types":"prop-types","react":"react"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _AsyncValidationInput = _interopRequireDefault(require("../Form/AsyncValidationInput.jsx"));

var _Label = _interopRequireDefault(require("../Form/Label.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  usernameLabel: _propTypes.string,
  verifyUsernameEndpoint: _propTypes.string.isRequired,
  passwordLabel: _propTypes.string,
  confirmPasswordLabel: _propTypes.string,
  passwordSubtitle: _propTypes.string.isRequired,
  secondScreenHeaderText: _propTypes.string.isRequired
};
var defaultProps = {
  usernameLabel: "Username",
  passwordLabel: "Password",
  confirmPasswordLabel: "Confirm Password",
  optInLabel: "Get Emails from Bayer"
};

var Step1 = function Step1(props) {
  var usernameLabel = props.usernameLabel,
      verifyUsernameEndpoint = props.verifyUsernameEndpoint,
      passwordLabel = props.passwordLabel,
      confirmPasswordLabel = props.confirmPasswordLabel,
      passwordSubtitle = props.passwordSubtitle,
      secondScreenHeaderText = props.secondScreenHeaderText;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h2", null, secondScreenHeaderText), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__fields"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "username"
  }, usernameLabel, /*#__PURE__*/_react.default.createElement(_AsyncValidationInput.default, {
    name: "username",
    validateUrl: verifyUsernameEndpoint,
    placeholder: "Username",
    validText: "Available",
    renderError: function renderError(username) {
      return "".concat(username, " is already taken");
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "username"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "password"
  }, passwordLabel, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    type: "password",
    name: "password",
    placeholder: "Password"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "password"
  }))), /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "confirmPassword"
  }, confirmPasswordLabel, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    type: "password",
    name: "confirmPassword",
    placeholder: "Password"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "confirmPassword"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__sub-note registration__sub-note--password",
    dangerouslySetInnerHTML: {
      __html: passwordSubtitle
    }
  })));
};

Step1.propTypes = propTypes;
Step1.defaultProps = defaultProps;
var _default = Step1;
exports.default = _default;

},{"../Form/AsyncValidationInput.jsx":7,"../Form/Label.jsx":8,"formik":"formik","prop-types":"prop-types","react":"react"}],23:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _RegistrationContext = require("./RegistrationContext.jsx");

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _ServerErrors = _interopRequireDefault(require("../Form/ServerErrors.jsx"));

var _Label = _interopRequireDefault(require("../Form/Label.jsx"));

var _TooltipInput = _interopRequireDefault(require("../Form/TooltipInput.jsx"));

var _Radio = _interopRequireDefault(require("../Radio/Radio.jsx"));

var _RadioGroup = _interopRequireDefault(require("../Radio/RadioGroup.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  acceptedTermsAndConditionsText: _propTypes.string.isRequired,
  finalHeaderText: _propTypes.string.isRequired,
  finalBodyText: _propTypes.string.isRequired,
  bayerPlusFinalHeaderText: _propTypes.string.isRequired,
  bayerPlusFinalBodyText: _propTypes.string.isRequired,
  completeRegistrationText: _propTypes.string.isRequired,
  footerText: _propTypes.string.isRequired,
  techIdLookupText: _propTypes.string.isRequired,
  onTechIdClick: _propTypes.func.isRequired,
  onCompleteRegistrationClick: _propTypes.func.isRequired,
  serverErrors: (0, _propTypes.arrayOf)(_propTypes.string),
  isSubmitting: _propTypes.bool.isRequired,
  recaptchaRef: _propTypes.func.isRequired,
  isFarmProgress: _propTypes.bool,
  isHighflyer: _propTypes.bool,
  optInLabel: _propTypes.string,
  optInText: _propTypes.string,
  optInYesText: _propTypes.string,
  optInNoText: _propTypes.string,
  optInFooterText: _propTypes.string,
  bayerPlusEnrollmentLabel: _propTypes.string,
  bayerPlusEnrollmentText: _propTypes.string,
  isBayerPlusRegistration: _propTypes.bool,
  finalOpenModalLinkText: _propTypes.string,
  climateFieldViewTitle: _propTypes.string,
  climateFieldViewDescription: _propTypes.string,
  climateFieldViewOptInText: _propTypes.string,
  climateFieldViewOptOutText: _propTypes.string,
  climateFieldViewEmailLabel: _propTypes.string,
  climateFieldViewEmailDescription: _propTypes.string,
  climateFieldViewEmailTooltip: _propTypes.string,
  climateFieldViewPhoneLabel: _propTypes.string,
  climateFieldViewPhoneDescription: _propTypes.string,
  climateFieldViewPhoneTooltip: _propTypes.string,
  climateFieldViewError: _propTypes.string,
  climateFieldViewDealerEmailDescription: _propTypes.string,
  climateFieldViewDealerEmailLabel: _propTypes.string,
  climateFieldViewDealerEmailPlaceholder: _propTypes.string,
  climateFieldViewDealerEmailSubtitle: _propTypes.string,
  climateFieldViewDealerEmailTooltip: _propTypes.string,
  formValues: _propTypes.object,
  errors: _propTypes.object,
  touched: _propTypes.object,
  setFieldValue: _propTypes.func,
  setFieldTouched: _propTypes.func
};
var defaultProps = {
  serverErrors: [],
  isFarmProgress: false,
  isHighflyer: false,
  climateFieldViewTitle: "Get Climate Fieldview™ Plus free for one year.",
  climateFieldViewDescription: "Signup for a Bayer PLUS program and recceive FieldView™ Plus free for one year (new and current subscriptions eligible)",
  climateFieldViewOptInText: "Yes, I am interested in a free year of FieldView™ PLUS",
  climateFieldViewOptOutText: "No thank you, not today",
  climateFieldViewEmailLabel: "Preferred email address",
  climateFieldViewEmailDescription: "If you already have a Climate FieldView™ email address, please enter it in the box below.",
  climateFieldViewEmailTooltip: "Don’t have a Climate FieldView email address? No problem. Simply enter the email address you wish to use for this account.",
  climateFieldViewPhoneLabel: "Preferred phone number",
  climateFieldViewPhoneDescription: "Please enter your preferred phone number in the box below.",
  climateFieldViewPhoneTooltip: "The phone number you enter here will be used only if we need to contact you.",
  climateFieldViewError: "Ooops please enter Preferred email and Preferred phone number",
  optInYesText: "Yes, please sign me up.",
  optInNoText: "No thank you, not today.",
  optInFooterText: "Bayer values your privarcy. For more information about how Bayer handles personal data, please read our Privacy Statement.",
  optInError: "Ooops please choose your option whether to subscribe in Bayer information, and products updates or not"
};

var Step2 = function Step2(props) {
  var _useRegistrationConte = (0, _RegistrationContext.useRegistrationContext)(),
      data = _useRegistrationConte.data,
      isTechIdModalOpen = _useRegistrationConte.state.isTechIdModalOpen,
      setTechIdModalOpen = _useRegistrationConte.actions.setTechIdModalOpen;

  var acceptedTermsAndConditionsText = props.acceptedTermsAndConditionsText,
      finalBodyText = props.finalBodyText,
      bayerPlusFinalBodyText = props.bayerPlusFinalBodyText,
      completeRegistrationText = props.completeRegistrationText,
      footerText = props.footerText,
      techIdLookupText = props.techIdLookupText,
      onTechIdClick = props.onTechIdClick,
      onCompleteRegistrationClick = props.onCompleteRegistrationClick,
      serverErrors = props.serverErrors,
      isSubmitting = props.isSubmitting,
      finalHeaderText = props.finalHeaderText,
      bayerPlusFinalHeaderText = props.bayerPlusFinalHeaderText,
      recaptchaRef = props.recaptchaRef,
      isFarmProgress = props.isFarmProgress,
      isHighflyer = props.isHighflyer,
      optInLabel = props.optInLabel,
      optInText = props.optInText,
      optInYesText = props.optInYesText,
      optInNoText = props.optInNoText,
      optInFooterText = props.optInFooterText,
      bayerPlusEnrollmentLabel = props.bayerPlusEnrollmentLabel,
      bayerPlusEnrollmentText = props.bayerPlusEnrollmentText,
      isBayerPlusRegistration = props.isBayerPlusRegistration,
      finalOpenModalLinkText = props.finalOpenModalLinkText,
      climateFieldViewTitle = props.climateFieldViewTitle,
      climateFieldViewDescription = props.climateFieldViewDescription,
      climateFieldViewOptInText = props.climateFieldViewOptInText,
      climateFieldViewOptOutText = props.climateFieldViewOptOutText,
      climateFieldViewEmailLabel = props.climateFieldViewEmailLabel,
      climateFieldViewEmailDescription = props.climateFieldViewEmailDescription,
      climateFieldViewEmailTooltip = props.climateFieldViewEmailTooltip,
      climateFieldViewPhoneLabel = props.climateFieldViewPhoneLabel,
      climateFieldViewPhoneDescription = props.climateFieldViewPhoneDescription,
      climateFieldViewPhoneTooltip = props.climateFieldViewPhoneTooltip,
      climateFieldViewError = props.climateFieldViewError,
      climateFieldViewDealerEmailDescription = props.climateFieldViewDealerEmailDescription,
      climateFieldViewDealerEmailLabel = props.climateFieldViewDealerEmailLabel,
      climateFieldViewDealerEmailPlaceholder = props.climateFieldViewDealerEmailPlaceholder,
      climateFieldViewDealerEmailSubtitle = props.climateFieldViewDealerEmailSubtitle,
      climateFieldViewDealerEmailTooltip = props.climateFieldViewDealerEmailTooltip,
      optInError = props.optInError,
      formValues = props.formValues,
      errors = props.errors,
      touched = props.touched,
      setFieldValue = props.setFieldValue,
      setFieldTouched = props.setFieldTouched,
      pauseBayerPlusEnrollment = props.pauseBayerPlusEnrollment;
  var condFinalHeaderText = isBayerPlusRegistration ? bayerPlusFinalHeaderText : finalHeaderText;
  var condFinalBodyText = isBayerPlusRegistration ? bayerPlusFinalBodyText : finalBodyText;
  (0, _react.useEffect)(function () {
    //Prepopulate CFV Email and Phone Number Fields
    //const optInFieldview = R.propEq("climateFieldViewChoice", "yes")(formValues);
    // if (optInFieldview && R.isEmpty(formValues.climateFieldViewEmail) && (!R.has("climateFieldViewEmail")(touched) || !touched.climateFieldViewEmail)) {
    //   setFieldValue("climateFieldViewEmail", formValues.email, true);
    //   setFieldTouched("climateFieldViewEmail", true);
    // }
    // if(optInFieldview && R.isEmpty(formValues.climateFieldViewPhoneNumber) && (!R.has("climateFieldViewPhoneNumber")(touched) || !touched.climateFieldViewPhoneNumber)){
    //   setFieldValue("climateFieldViewPhoneNumber", formValues.phoneNumber, true);
    //   setFieldTouched("climateFieldViewPhoneNumber", true);
    // }
    if (R.propEq("climateFieldViewChoice", "no")(formValues)) {
      setFieldValue("climateFieldViewEmail", "", true);
      setFieldValue("climateFieldViewPhoneNumber", "", true);
      setFieldTouched("climateFieldViewEmail", false);
      setFieldTouched("climateFieldViewPhoneNumber", false);
    }
  }, [formValues, touched, setFieldValue, setFieldTouched]);

  var handleTechIdModalLinkClick = function handleTechIdModalLinkClick(e) {
    e.preventDefault();
    setTechIdModalOpen(true);
  };

  var fieldViewChoiceHasError = function fieldViewChoiceHasError() {
    var climateFieldViewEmailHasError = R.has("climateFieldViewEmail");
    var climateFieldViewPhoneHasError = R.has("climateFieldViewPhoneNumber");
    var emailTouched = R.has("climateFieldViewEmail")(touched) || touched.climateFieldViewEmail;
    var phoneTouched = R.has("climateFieldViewPhoneNumber")(touched) || touched.climateFieldViewPhoneNumber;
    return R.anyPass([climateFieldViewEmailHasError, climateFieldViewPhoneHasError])(errors) && R.propEq("climateFieldViewChoice", "yes")(formValues) && (emailTouched || emailTouched == true || phoneTouched || phoneTouched == true);
  };

  var optInHasError = function optInHasError() {
    var optInTouched = R.has("optIn")(touched) || touched.optInTouched;
    return !R.propEq("optIn", "yes")(formValues) && !R.propEq("optIn", "no")(formValues) && (optInTouched || optInTouched == true);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h2", null, climateFieldViewTitle), fieldViewChoiceHasError() && /*#__PURE__*/_react.default.createElement("p", {
    className: "form__error form__error--fieldview"
  }, climateFieldViewError), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: climateFieldViewDescription
    }
  }), " "), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__fields"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form__row registration__radio-group ".concat(errors.climateFieldViewChoice && touched.climateFieldViewChoice ? "registration__radio-group--has-errors" : "")
  }, /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
    name: "climateFieldViewChoice"
  }, errors.climateFieldViewChoice && touched.climateFieldViewChoice && /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "climateFieldViewChoice"
  })), /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "climateFieldViewChoice",
    value: "yes",
    render: function render(_ref) {
      var field = _ref.field;
      return /*#__PURE__*/_react.default.createElement(_Radio.default, {
        defaultValue: "yes",
        onChange: field.onChange,
        name: field.name
      }, climateFieldViewOptInText);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration-form__hidden-fields",
    style: {
      display: formValues.climateFieldViewChoice === "yes" ? "block" : "none"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "climateFieldViewEmail"
  }, climateFieldViewEmailLabel, /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__field-description"
  }, climateFieldViewEmailDescription), /*#__PURE__*/_react.default.createElement(_TooltipInput.default, {
    name: "climateFieldViewEmail",
    placeholder: "email@host.com"
  }, /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: climateFieldViewEmailTooltip
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "climateFieldViewEmail"
  }))), /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "climateFieldViewPhoneNumber"
  }, climateFieldViewPhoneLabel, /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__field-description"
  }, climateFieldViewPhoneDescription), /*#__PURE__*/_react.default.createElement(_TooltipInput.default, {
    name: "climateFieldViewPhoneNumber",
    placeholder: "xxx-xxx-xxxx"
  }, /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: climateFieldViewPhoneTooltip
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "climateFieldViewPhoneNumber"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__split-row"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    name: "climateFieldViewDealerEmail"
  }, climateFieldViewDealerEmailLabel, /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__field-description"
  }, climateFieldViewDealerEmailDescription), /*#__PURE__*/_react.default.createElement(_TooltipInput.default, {
    name: "climateFieldViewDealerEmail",
    placeholder: climateFieldViewDealerEmailPlaceholder
  }, /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: climateFieldViewDealerEmailTooltip
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__sub-note--cfv"
  }, climateFieldViewDealerEmailSubtitle)))), /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "climateFieldViewChoice",
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/_react.default.createElement(_Radio.default, {
        defaultValue: "no",
        onChange: field.onChange,
        name: field.name
      }, climateFieldViewOptOutText);
    }
  }))))), formValues.climateFieldViewChoice && /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h2", null, optInLabel), optInHasError() && /*#__PURE__*/_react.default.createElement("p", {
    className: "form__error form__error--fieldview"
  }, optInError), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: optInText
    }
  }), " "), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__fields"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form__row registration__radio-group ".concat(errors.optIn && touched.optIn ? "registration__radio-group--has-errors" : "")
  }, /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
    name: "optIn"
  }, errors.optIn && touched.optIn && /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "optIn"
  })), /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "optIn",
    value: "yes",
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_react.default.createElement(_Radio.default, {
        defaultValue: "yes",
        onChange: field.onChange,
        name: field.name
      }, optInYesText);
    }
  }), /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "optIn",
    render: function render(_ref4) {
      var field = _ref4.field;
      return /*#__PURE__*/_react.default.createElement(_Radio.default, {
        defaultValue: "no",
        onChange: field.onChange,
        name: field.name
      }, optInNoText);
    }
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__section_footer-text",
    dangerouslySetInnerHTML: {
      __html: optInFooterText
    }
  })), formValues.optIn && /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("h2", null, condFinalHeaderText), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: condFinalBodyText
    }
  }), " ", isBayerPlusRegistration && /*#__PURE__*/_react.default.createElement("a", {
    href: "#what-is-tech-id",
    onClick: handleTechIdModalLinkClick
  }, finalOpenModalLinkText)), !isFarmProgress && !isHighflyer && !isBayerPlusRegistration && !pauseBayerPlusEnrollment && /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__checkbox registration__bayerplus"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    type: "checkbox",
    name: "bayerPlusEnrollment"
  }), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "checkbox__custom"
  }), " ", /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, bayerPlusEnrollmentLabel), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "registration__optional"
  }, "(optional)"), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: bayerPlusEnrollmentText
    }
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__checkbox registration__terms"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    type: "checkbox",
    name: "privacyPolicy"
  }), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "checkbox__custom"
  }), " ", /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: acceptedTermsAndConditionsText
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "privacyPolicy"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__captcha"
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: recaptchaRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form__error"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: "g-recaptcha-response"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__btn-holder"
  }, (isFarmProgress || isHighflyer || isBayerPlusRegistration && !pauseBayerPlusEnrollment) && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button",
    onClick: onTechIdClick,
    disabled: isSubmitting || serverErrors.length > 0
  }, techIdLookupText), (!isFarmProgress && !isHighflyer && !isBayerPlusRegistration || !isFarmProgress && !isHighflyer && isBayerPlusRegistration && pauseBayerPlusEnrollment) && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button",
    onClick: onCompleteRegistrationClick,
    disabled: isSubmitting || serverErrors.length > 0
  }, completeRegistrationText)), /*#__PURE__*/_react.default.createElement(_ServerErrors.default, {
    serverErrors: serverErrors
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "registration__footer-text",
    dangerouslySetInnerHTML: {
      __html: footerText
    }
  })));
};

Step2.propTypes = propTypes;
Step2.defaultProps = defaultProps;
var _default = Step2;
exports.default = _default;

},{"../Form/Label.jsx":8,"../Form/ServerErrors.jsx":9,"../Form/TooltipInput.jsx":10,"../Radio/Radio.jsx":17,"../Radio/RadioGroup.jsx":18,"./RegistrationContext.jsx":20,"formik":"formik","prop-types":"prop-types","ramda":"ramda","react":"react"}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRecaptchaCheckbox;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CAPTCHA_CALLBACK_NAME = "captchaCheckboxCallback";
var ONLOAD_CALLBACK = "onCaptchaLoadCallback";

function useRecaptchaCheckbox(captchaSiteKey) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      captchaId = _useState2[0],
      setCaptchaId = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      captchaToken = _useState4[0],
      setCaptchaToken = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      ready = _useState6[0],
      setReady = _useState6[1]; // add google recaptcha v2 script to the page head
  // https://developers.google.com/recaptcha/docs/display


  (0, _react.useEffect)(function () {
    var script = document.createElement("script");

    window[ONLOAD_CALLBACK] = function () {
      setReady(true);
    };

    script.src = "https://www.google.com/recaptcha/enterprise.js?onload=".concat(ONLOAD_CALLBACK, "&render=explicit");
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, [captchaSiteKey]); // render the checkbox
  // https://medium.com/@teh_builder/ref-objects-inside-useeffect-hooks-eb7c15198780

  var recaptchaRef = (0, _react.useCallback)(function (node) {
    window[CAPTCHA_CALLBACK_NAME] = function (token) {
      setCaptchaToken(token);
    }; // https://developers.google.com/recaptcha/docs/display#js_api


    if (node && ready && window.grecaptcha && captchaId === null) {
      var id = window.grecaptcha.enterprise.render(node, {
        sitekey: captchaSiteKey,
        callback: CAPTCHA_CALLBACK_NAME,
        action: 'login'
      });
      setCaptchaId(id);
    }
  }, [captchaId, ready, captchaSiteKey]);
  return {
    recaptchaRef: recaptchaRef,
    captchaToken: captchaToken
  };
}

},{"react":"react"}],25:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var R = _interopRequireWildcard(require("ramda"));

var _Registration = _interopRequireDefault(require("../components/Registration/Registration.jsx"));

var _RegistrationContext = require("../components/Registration/RegistrationContext.jsx");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener("DOMContentLoaded", function () {
  var mountClass = ".js-registration-mount";
  var mountNode = document.querySelector(mountClass);

  if (!mountNode) {
    console.error("".concat(mountClass, " element not found!"));
    return;
  }

  var data = R.compose(JSON.parse, function (node) {
    return node.getAttribute("data-model");
  })(mountNode);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_RegistrationContext.RegistrationProvider, {
    data: data
  }, /*#__PURE__*/_react.default.createElement(_Registration.default, null)), mountNode);
});

},{"../components/Registration/Registration.jsx":19,"../components/Registration/RegistrationContext.jsx":20,"ramda":"ramda","react":"react","react-dom":"react-dom"}]},{},[25]);
